import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getDemandeReportsDataTableStructure } from './demande-reports-data-table';

@Component({
  selector: 'sm-demande-reports',
  standalone: true,
  imports: [CommonModule, DataTableBuilderComponent, TranslateModule],
  template: `
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-150 dark:border-gray-750 p-6 my-4 w-full">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center gap-2">
        <i class="pi pi-list text-primary"></i>
        {{ 'clarification.reports.form.demande_table.title' | translate }}
      </h3>
      <sm-data-table-builder
        [dataTableObject]="dataTableObject"
        [datas]="(demandeReports$ | async) || []">
      </sm-data-table-builder>
    </div>
  `,
})
export class DemandeReportsComponent implements OnInit {
  @Input() demandeReports$!: Observable<any[]>;

  dataTableObject!: DynamicDataTable;

  ngOnInit(): void {
    this.dataTableObject = getDemandeReportsDataTableStructure();
  }
}
